var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 69,
    viewBox: "0 0 72 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M67.61 64.126c1.275 0 2.308.99 2.308 2.211 0 1.145-.908 2.087-2.072 2.2l-.236.012H32.09c-1.274 0-2.308-.99-2.308-2.212 0-1.145.908-2.087 2.072-2.2l.236-.011h35.52zM49.453 3.414c4.75-4.552 12.45-4.552 17.2 0 4.749 4.551 4.749 11.93 0 16.482l-44.13 42.291c-.296.284-.667.485-1.073.582L2.87 67.221c-1.69.405-3.222-1.062-2.799-2.682l4.645-17.807c.102-.389.312-.744.607-1.027zm12.769 4.245c-2.824-2.706-7.402-2.706-10.225 0l-41.85 40.106L6.74 60.83l13.634-3.269 41.849-40.103c2.73-2.616 2.82-6.802.273-9.523z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H72V69H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDefault);
export default __webpack_public_path__ + "static/media/edit-default.434f6bbaa0f9c479072e55fa7633eb11.svg";
export { ForwardRef as ReactComponent };